import { HttpParams } from '@angular/common/http';
import { Component, HostListener, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { AddressInfo, TableDocTypes } from 'src/app/entities/various';
import { LoginService } from 'src/app/services/login/login.service';
import { UserService } from 'src/app/services/users/user.service';
import { Company} from 'src/app/entities/various';
import { ThisReceiver } from '@angular/compiler/public_api';

@Component({
  selector: 'app-ricerca-azienda',
  templateUrl: './ricerca-azienda.component.html',
  styleUrls: ['./ricerca-azienda.component.css']
})

export class RicercaAziendaComponent implements OnInit {

  innerWidth: number | undefined = window.innerWidth;
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.innerWidth = window.innerWidth;
  }
  
  
  titleSearch: string = "";
  
  loading : boolean = false;
  
  listAziende: any | Company[];
  haserror : boolean = false;

  constructor(public translate: TranslateService, public activeModal: NgbActiveModal, private loginService: LoginService, private userService: UserService) {
    this.innerWidth = window.innerWidth;
  }

  async ngOnInit() {
  }

  close(){
    this.activeModal.close(null);
  }

  search(event: any){
    if(this.titleSearch.length < 3 ) return;
    if(!event || event.keyCode == 13){
      this.retriveList();
    }
  }

  private async retriveList(){
    this.loading = true;
    try{
    let response : Company[] | undefined = await this.userService.cercaAziende(this.titleSearch);
    if(response.length > 0){
        this.listAziende=response;
        this.haserror=false;
        //console.log(response);
    }else{
      this.haserror=true;
    }
    }catch(e){
      this.close();
    }
    this.loading = false;
  }





  public selectOne(azienda: any){
        for(var i =0; i< this.listAziende.length; i++){
          if(this.listAziende[i].id!=azienda.id)
              this.listAziende[i].selected=false;
        }
  }

  public save(){
    for(var i =0; i< this.listAziende.length; i++){
      if(this.listAziende[i].selected)
        this.activeModal.close(this.listAziende[i]);  
    }
    this.activeModal.close(null);
  }

}
